// @flow
import type {SagaIterator} from 'redux-saga';

import {APP, COUPON} from 'constants/actions';
import {REFERRAL_PROMOCODE_KEY} from 'constants/product';

import {sessionStore} from 'libs/storage/storage';
import {getUrlParameter} from 'libs/url';
import {call, takeEvery} from 'redux-saga/effects';

/**
 * Saves promocode into session store to future use in discount price
 */
export function* saveReferralPromo(): SagaIterator {
    const promo = yield call(getUrlParameter, 'promo');
    if (promo) {
        yield call([sessionStore, 'set'], REFERRAL_PROMOCODE_KEY, promo);
    }
}

/**
 * We should reset promocode if customer provide a new promocode
 */
export function* resetPromoCode(): SagaIterator {
    yield call([sessionStore, 'set'], REFERRAL_PROMOCODE_KEY, '');
}

/**
 * Begin of saga
 */
export default function* referralPromoCodeSaga(): SagaIterator {
    yield takeEvery(APP.SAVE_LOCATION, saveReferralPromo);
    yield takeEvery(
        [`${COUPON.ADD_COUPON}_FULFILLED`, `${COUPON.REMOVE_COUPON}_FULFILLED`],
        resetPromoCode,
    );
}
